
import { Component, Prop, Emit } from 'vue-property-decorator'
import { AppInput } from '@/components'
import { appAccountEntity } from '@/models/models'
import CommonForm from '@/mixins/CommonForm'
import { CNPJ_MASK } from '@/constants/cnpj'
import '@/extensions/Date'
import '@/extensions/string'

@Component({
    components: {
        AppInput,
    },
})
export default class DetailAppleDeveloperProgramForm extends CommonForm {
    @Prop() public value?: AppAccountEntity

    public readonly CNPJ_MASK = CNPJ_MASK

    get account(): AppAccountEntity {
        return this.value ? this.value : appAccountEntity
    }

    get developerProgramRegisteredAt() {
        if (
            this.account.developerProgramRegisteredAt == null ||
            this.account.developerProgramRegisteredAt.isEmpty()
        ) {
            return ''
        }
        return new Date(
            this.account.developerProgramRegisteredAt,
        ).toHTMLFormat()
    }

    @Emit('accountTypeChanged')
    public accountTypeChanged(event: any) {
        this.update(this.account, 'type', event)
        return event
    }
}
